/**
 * API 请求前缀：.env.development 为空（同源 /api + 代理），.env.production 为 /api
 */
export const REACT_APP_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? '';

/** 拼出完整 API 路径，如 getApiUrl('aiapps') => '/api/aiapps' 或 http://localhost:5001/api/aiapps */
export function getApiUrl(path: string): string {
  const base = REACT_APP_API_BASE_URL || '';
  const segment = path.replace(/^\//, '');
  if (!base) return `/api/${segment}`;
  const root = base.replace(/\/$/, '');
  const isAbsolute = /^https?:\/\//i.test(root);
  const apiPath = isAbsolute ? `${root}/api/${segment}` : `${root}/${segment}`;
  return apiPath;
}
